(() => {
  // Only run on landing layout pages that include the lightbox root.
  if (!document.body.classList.contains('template-landing')) return;

  const root = document.querySelector('[data-landing-lightbox-root]');
  if (!root) return;

  const imageEl = root.querySelector('[data-landing-lightbox-image]');
  const downloadEl = root.querySelector('[data-landing-lightbox-download]');
  const titleEl = root.querySelector('[data-landing-lightbox-title]');
  const stageEl = root.querySelector('[data-landing-lightbox-stage]');
  const zoomBtn = root.querySelector('[data-landing-lightbox-zoom]');
  const closeEls = root.querySelectorAll('[data-landing-lightbox-close]');
  let lastFocus = null;
  let scale = 1;

  const setZoom = (next) => {
    scale = next;
    imageEl.style.transform = `scale(${scale})`;
    root.classList.toggle('is-zoomed', scale > 1);
    if (zoomBtn) {
      const zoomed = scale > 1;
      zoomBtn.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
      zoomBtn.setAttribute('aria-label', zoomed ? 'Zoom out' : 'Zoom in');
    }
    if (stageEl) {
      stageEl.scrollTop = 0;
      stageEl.scrollLeft = 0;
    }
  };

  const close = () => {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('landing-lightbox-open');
    setZoom(1);
    imageEl.removeAttribute('src');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  const open = (trigger) => {
    const src = trigger.getAttribute('data-lightbox-src') || trigger.getAttribute('href');
    if (!src) return;

    const title = trigger.getAttribute('data-lightbox-title') || '';
    lastFocus = trigger;
    imageEl.src = src;
    imageEl.alt = title;
    if (titleEl) titleEl.textContent = title;
    if (downloadEl) downloadEl.href = src;
    setZoom(1);
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('landing-lightbox-open');
    const closeBtn = root.querySelector('[data-landing-lightbox-close="button"]');
    if (closeBtn) closeBtn.focus();
  };

  // Only the download text/button links open the popup — not images.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.landing-page__download-link[data-landing-lightbox]');
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  });

  closeEls.forEach((el) => {
    el.addEventListener('click', (event) => {
      event.preventDefault();
      close();
    });
  });

  if (zoomBtn) {
    zoomBtn.addEventListener('click', () => {
      setZoom(scale > 1 ? 1 : 2);
    });
  }

  document.addEventListener('keydown', (event) => {
    if (root.hidden) return;
    if (event.key === 'Escape') close();
  });
})();
